// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Icon);
    global.Icon = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Icon) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IconButton = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
  function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var P_CLASS_NAMES = {
    sm: 'cop-p-2',
    base: 'cop-p-2.5'
  };
  var VARIANT_CLASS_NAMES = {
    primary: ['cop-bg-[#212B36]', 'cop-text-white', 'cop-border-0'],
    secondary: ['cop-border', 'cop-border-solid', 'cop-border-slate-200', 'cop-bg-transparent', 'cop-text-current'],
    minimal: ['cop-border-0', 'cop-bg-transparent', 'cop-text-current']
  };
  var IconButton = _exports.IconButton = function IconButton(_ref) {
    var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      icon = _ref.icon,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'base' : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: [P_CLASS_NAMES[size]].concat(_toConsumableArray(VARIANT_CLASS_NAMES[variant]), ['cop-rounded', 'hover:cop-opacity-80', 'cop-transition-opacity', 'cop-flex', 'cop-items-center', 'cop-shadow-none', className]).join(' '),
      onClick: onClick,
      "aria-label": label
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: icon,
      className: ['cop-w-3', 'cop-h-3', '[&>path]:cop-fill-current', '[&>path]:cop-stroke-current'].join(' ')
    })));
  };
});
